import 'apps/hiring/styles/components/applicant/qualities.scss';
import React from 'react';
import PropTypes from 'prop-types';
import Image from 'library/components/image';
import EscapedTag from 'library/components/escaped-tag';

class ApplicantQualities extends React.Component {
  static propTypes = {
    qualities: PropTypes.array,
    loading: PropTypes.bool
  }

  mapQualities = ({ id, name, link_name, insight, description, category }) => (
    <div key={id} className="hiring-application-quality">
      <Image width={150} height={150} style={{maxWidth: '150px',height: '150px'}} src={`${__ASSET_PATH__}/icons/qualities/${link_name}.svg`} />
      <div>
        <div className="hiring-application-quality-category">Leading {category}</div>
        <div className="hiring-application-quality-name">{ name }</div>
        <EscapedTag>{ insight }</EscapedTag>
      </div>
    </div>
  )

  render() {
    const {
      qualities,
      loading
    } = this.props;

    if (loading) {
      return <h1>Loading</h1>;
    }

    return (
      <div>
        {
          qualities.map(this.mapQualities)
        }
      </div>
    );
  }
}

export default ApplicantQualities;
